<template>
  <div class="container">
    <div class="title">数据看板/PO看板</div>

    <el-card class="box-card">
      <el-row :gutter="20">
        <el-col :span="12">
          <div class="card-header">PO统计</div>
          <el-table :data="poStatistics" border>
            <el-table-column prop="category" label="类别"></el-table-column>
            <el-table-column prop="total" label="汇总"></el-table-column>
            <el-table-column prop="thisYear" label="今年"></el-table-column>
            <el-table-column prop="last30Days" label="近30天"></el-table-column>
            <el-table-column prop="last7Days" label="近7天"></el-table-column>
          </el-table>
        </el-col>
        <el-col :span="12">
          <div class="card-header">PO超时</div>
          <el-table :data="poTimeout" border>
            <el-table-column prop="category" label="类别"></el-table-column>
            <el-table-column prop="total" label="统计汇总"></el-table-column>
            <el-table-column prop="thisYear" label="今年"></el-table-column>
            <el-table-column prop="last30Days" label="近30天"></el-table-column>
            <el-table-column prop="last7Days" label="近7天"></el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </el-card>

    <el-card class="box-card mt-20">
      <el-row :gutter="20">
        <el-col :span="12">
          <div class="card-header">PO统计（区域-园区）</div>
          <el-table :data="poRegionStatistics" border>
            <el-table-column prop="category" label="类别"></el-table-column>
            <el-table-column prop="total" label="汇总"></el-table-column>
            <el-table-column prop="thisYear" label="今年"></el-table-column>
            <el-table-column prop="last30Days" label="近30天"></el-table-column>
            <el-table-column prop="last7Days" label="近7天"></el-table-column>
          </el-table>
        </el-col>

        <el-col :span="12">
          <div class="card-header">PO受理/驳回</div>
          <el-table :data="poHandling" border>
            <el-table-column prop="category" label="类别"></el-table-column>
            <el-table-column prop="poCount" label="PO数"></el-table-column>
            <el-table-column prop="accepted" label="受理"></el-table-column>
            <el-table-column prop="rejected" label="驳回"></el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </el-card>
    <el-card class="box-card mt-20">
      <div class="card-header">PO分析（柱状图-近12月/按月/按类别）</div>
      <div style="height: 400px">
        <POAnalysisChart />
      </div>
    </el-card>
  </div>
</template>

<script>
import POAnalysisChart from '@/components/POAnalysisChart';
import {
  getPOStatistics,
  getPoTimeoutStatistics,
  getPoRegionStatistics,
  getPoAcceptStatistics,
} from '@/api/po_board';

export default {
  components: {
    POAnalysisChart,
  },
  data() {
    return {
      poStatistics: [
        { category: '汇总' },
        { category: '服务器' },
        { category: '网络' },
        { category: '资产' },
        { category: '人力' },
        { category: '其他' },
      ],
      poRegionStatistics: [
        { category: '汇总' },
        { category: '清远-清新' },
        { category: '上海-临港' },
        { category: '上海-书院' },
        { category: '杭州-东冠' },
        { category: '怀来-东园' },
        { category: '惠州-联丰' },
        { category: '昆山-千灯' },
        { category: '韶关-沐阳' },
      ],
      poTimeout: [
        { category: '统计汇总' },
        { category: '服务器' },
        { category: '网络' },
        { category: '资产' },
        { category: '人力' },
        { category: '其他' },
      ],
      poHandling: [
        { category: 'PO数' },
        { category: '清远-清新' },
        { category: '上海-临港' },
        { category: '上海-书院' },
        { category: '杭州-东冠' },
        { category: '怀来-东园' },
        { category: '惠州-联丰' },
        { category: '昆山-千灯' },
        { category: '韶关-沐阳' },
      ],
    };
  },
  async created() {
    await this.fetchPOStatistics();
    await this.fetchPOTimeoutStatistics();
    await this.fetchPORegionStatistics();
    await this.fetchPOAcceptStatistics();
  },
  methods: {
    async fetchPOStatistics() {
      try {
        const { data } = await getPOStatistics();
        const { all_time, this_year, last_30_days, last_7_days } = data.data;
        this.poStatistics = all_time.map((item, index) => ({
          category: item.type,
          total: item.count,
          thisYear: this_year[index].count,
          last30Days: last_30_days[index].count,
          last7Days: last_7_days[index].count,
        }));
      } catch (error) {
        console.error('获取PO单统计数据失败:', error);
      }
    },
    async fetchPORegionStatistics() {
      try {
        const { data } = await getPoRegionStatistics();
        const { all_time, this_year, last_30_days, last_7_days } = data.data;
        const regionTypes = [
          'total',
          '清远-清新',
          '上海-临港',
          '上海-书院',
          '杭州-东冠',
          '张家口-怀来东园',
          '惠州-联丰',
          '昆山-千灯',
          '韶关-沐阳',
        ];

        this.poRegionStatistics = regionTypes.map((type) => {
          const allTimeData = all_time.find(
            (item) => item.type === (type === '张家口-怀来东园' ? '张家口-怀来东园' : type)
          );
          const thisYearData = this_year.find(
            (item) => item.type === (type === '张家口-怀来东园' ? '张家口-怀来东园' : type)
          );
          const last30DaysData = last_30_days.find(
            (item) => item.type === (type === '张家口-怀来东园' ? '张家口-怀来东园' : type)
          );
          const last7DaysData = last_7_days.find(
            (item) => item.type === (type === '张家口-怀来东园' ? '张家口-怀来东园' : type)
          );

          return {
            category: type === 'total' ? '汇总' : type === '张家口-怀来东园' ? '怀来-东园' : type,
            total: allTimeData ? parseInt(allTimeData.count) : 0,
            thisYear: thisYearData ? parseInt(thisYearData.count) : 0,
            last30Days: last30DaysData ? parseInt(last30DaysData.count) : 0,
            last7Days: last7DaysData ? parseInt(last7DaysData.count) : 0,
          };
        });
      } catch (error) {
        console.error('获取PO单园区统计数据失败:', error);
      }
    },
    async fetchPOTimeoutStatistics() {
      try {
        const { data } = await getPoTimeoutStatistics();
        const { all_time, this_year, last_30_days, last_7_days } = data.data;
        this.poTimeout = all_time.map((item, index) => ({
          category: item.type,
          total: item.count,
          thisYear: this_year[index].count,
          last30Days: last_30_days[index].count,
          last7Days: last_7_days[index].count,
        }));
      } catch (error) {
        console.error('获取PO单超时统计数据失败:', error);
      }
    },
    async fetchPOAcceptStatistics() {
      try {
        const { data } = await getPoAcceptStatistics();
        const { all_time } = data.data;

        this.poHandling = this.poHandling.map((item) => {
          const regionData = all_time.find((d) => {
            if (item.category === 'PO数') return d.type === 'total';
            if (item.category === '怀来-东园') return d.type === '张家口-怀来东园';
            return d.type === item.category;
          }) || { total: 0, accepted: 0, rejected: 0 };

          return {
            category: item.category,
            poCount: parseInt(regionData.total) || 0,
            accepted: parseInt(regionData.accepted) || 0,
            rejected: parseInt(regionData.rejected) || 0,
          };
        });
      } catch (error) {
        console.error('获取PO单受理/驳回统计数据失败:', error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  padding: 20px;
}
.title {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 30px;
}
.box-card {
  margin-bottom: 20px;
}
.card-header {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 15px;
}
.mt-20 {
  margin-top: 20px;
}
::v-deep .el-table {
  th.el-table__cell {
    background-color: #e4efdc !important;
    border: 0.5px solid #7eac55;
  }
  th.el-table__cell:first-child {
    border: 0.5px solid #7eac55;
  }
  .el-table__header {
    border-color: #7eac55;
  }
  td.el-table__cell {
    border: 0.5px solid #7eac55;
  }
  td.el-table__cell:first-child {
    background-color: #e4efdc;
  }
  tr:hover > td.el-table__cell:first-child {
    background-color: #e4efdc !important;
  }
}
::v-deep .el-table thead {
  color: #000;
}
</style>